import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client/react';
import { mdiAccount } from '@mdi/js';
import { useTranslation } from 'react-i18next';

import { CurrentUserDocument, IBasicFileFragment } from 'graphql/types';
import { Avatar, IAvatarProps } from 'common/components/Avatar';
import { Icon } from 'common/components/Icon';

export interface IProps extends IAvatarProps {
    user?: {
        name: string;
        profileImage?: IBasicFileFragment | null;
    };
}

export const UserAvatar = ({ user, ...other }: IProps) => {
    const [translate] = useTranslation();
    const [getCurrentUser, { data: currentUserData }] =
        useLazyQuery(CurrentUserDocument);

    useEffect(() => {
        // When user is not given we want to get the current User
        if (!user) getCurrentUser();
    }, [user, getCurrentUser]);

    const avatarUser = user || currentUserData?.currentUser;

    const userName = avatarUser?.name;
    const userImage = avatarUser?.profileImage?.url || undefined;

    return (
        <Avatar alt={translate('profile')} src={userImage} {...other}>
            {userName && userName[0]}
            {!userImage && !userName && <Icon path={mdiAccount} />}
        </Avatar>
    );
};
